import React from 'react';
import './index.scss';
import { useTranslation } from 'react-i18next';
import Messages from '../../constants/Messages';

const ErrorPage = () => {
	const { t } = useTranslation(['errors']);

	const handleClose = () => {
	   window.location.href = '/logout';
	};

	return (
		<div className="error-container">
			<div className="error-card">
				<div className="error-title">
					{t(Messages.NO_ACCESS_PRIVILEGE, { ns: 'errors' })}
				</div>
				<div className="button-group">
					<button className="close-btn" onClick={handleClose}>
						Close
					</button>
				</div>
			</div>
		</div>
	);
};

export default ErrorPage;

